import { render, staticRenderFns } from "./UcAccountSelector.yaml?vue&type=template&id=c6df1ee2&component"
import script from "./UcAccountSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcAccountSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports